export enum MskScoreLevels {
    Low = 69, // 69 and below
    Fair = 70, // 70-79
    Good = 80, // 80-89
    Excellent = 90 // 90-100
};
